import React from "react";

export function Tabs({
  tabs, activo, onChange,
}: {
  tabs: { key: string; label: string }[];
  activo: string;
  onChange: (key: string) => void;
}) {
  return (
    <div className="flex flex-wrap gap-2 mb-4 border-b border-borderc pb-3">
      {tabs.map((t) => (
        <button
          key={t.key}
          onClick={() => onChange(t.key)}
          className={`rounded-md px-3 py-1.5 text-sm font-semibold transition-colors ${
            activo === t.key ? "bg-navy text-white" : "bg-white border border-borderc text-slate-600 hover:bg-slate-50"
          }`}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
